import React, { Fragment } from 'react';

import { Text } from '@zapier/design-system';

import { CardsChecklist } from './CardsChecklist';
import { Status } from './PublishingSteps';

type Props = {
  currentStatus: Status;
  integrationId: number;
};

export function BetaChecklist({ currentStatus, integrationId }: Props) {
  return currentStatus === 'beta' ? (
    <Fragment>
      <Text margin="32px 0" tag="h3" textAlign="center" type="Body3">
        Beta Checklist - Complete these items to exit the beta program early
      </Text>
      <CardsChecklist appId={integrationId} order="normal" />
    </Fragment>
  ) : null;
}
